import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { useAuth } from "@/features/auth/AuthContext"
import { canSeeDepositModerationNav } from "@/features/deposits/depositNavPermissions"
import { LoadingBlock } from "@/widgets/LoadingBlock"

type RequireDepositModerationAccessProps = {
  children: ReactNode
}

/** Контент модерации при Moderate, Approve или любом `Moderate.Industry.*`; иначе — на главную. */
export const RequireDepositModerationAccess = ({ children }: RequireDepositModerationAccessProps) => {
  const { t } = useTranslation()
  const { grantedPolicies } = useAuth()
  const policiesResolved = grantedPolicies !== null

  if (!policiesResolved) {
    return <LoadingBlock variant="page" message={t("common.loading")} rootStyle={{ minHeight: "40vh" }} />
  }

  if (!canSeeDepositModerationNav(grantedPolicies)) {
    return <Navigate to="/" replace />
  }

  return children
}
